/*
  Разделы кабинета и то, что нужно роли, чтобы в них войти.

  Один перечень на меню (`Sidebar.jsx`) и на охранника маршрутов (`RouteGate.jsx`). До
  28.10.2026 права знало только меню: оно убирало пункты, а по прямому адресу `/import` или
  `/settings` оператор открывал экран и получал отказы сервера на каждый запрос (аудит,
  раздел 5.3). Две копии перечня разошлись бы при первой правке прав, поэтому копия одна.
*/

/*
  09.09.2026: у каждого раздела появился значок (`icon`). Он не украшение -
  десять одинаковых строк текста человек перечитывает каждый раз заново, а по
  форме значка нужный пункт находится боковым зрением. Значок ВСЕГДА идёт вместе
  с подписью: одни картинки в меню - это загадка, которую разгадывают наведением.
*/
export const SECTIONS = [
  { to: '/dashboard', title: 'Дашборд', need: 'view_dashboard', icon: 'dashboard' },
  { to: '/registry', title: 'Реестр', need: 'view_registry', badge: 'burning', icon: 'registry' },
  { to: '/conveyor', title: 'Конвейер', need: 'view_registry', icon: 'conveyor' },
  { to: '/import', title: 'Загрузка', need: 'run_import', icon: 'import' },
  { to: '/usage', title: 'Расход', need: 'view_dashboard', icon: 'usage' },
  { to: '/radar', title: 'Радар', need: 'view_dashboard', icon: 'radar' },
  { to: '/communications', title: 'Коммуникации', need: 'view_registry', icon: 'communications' },
  { to: '/enforcement', title: 'Исполнение', need: 'view_dashboard', icon: 'enforcement' },
  { to: '/reports', title: 'Отчёты', need: 'view_dashboard', icon: 'reports' },
  /*
    11.09.2026: у настроек стало ДВА разрешения вместо одного - внутри появился
    справочник судебных участков, а ведут его юрист и агент сопровождения.
    18.09.2026 добавилось третье: карточка организации, реквизиты, тарифы и
    режим давности перешли под `manage_organisation` и открылись тем же двоим.
    Вкладки внутри экрана фильтруются по тем же правам, разрешение на раздел
    только открывает дверь.
  */
  {
    to: '/settings',
    title: 'Настройки',
    need: ['manage_organisation', 'manage_settings', 'build_documents'],
    icon: 'settings',
  },
]

/* Экраны вне меню: карточка счёта и разговоры читаются теми, кто видит реестр; находки реестра
   банкротств разбирает тот, кто собирает документы (так же отвечает сервер). */
export const OFF_MENU_NEEDS = {
  accounts: 'view_registry',
  communication: 'view_registry',
  findings: 'build_documents',
}

/** Нужное разрешение раздела меню по адресу. */
export function needOf(path) {
  return SECTIONS.find((section) => section.to === path)?.need
}

/** Хотя бы одно из перечисленных разрешений есть у роли. */
export function allows(profile, need) {
  if (!need) return true
  return [need].flat().some((permission) => profile.permissions?.includes(permission))
}
